import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import SocialIcons from './SocialIcons';
import resolvePublicAsset from '../utils/resolvePublicAsset';

function Footer() {
  const linksInstitucionais = [
    {
      label: 'Home',
      to: '/'
    },
    {
      label: 'Quem Somos',
      to: '/sobre'
    },
    {
      label: 'Projetos',
      to: '/projetos'
    },
    {
      label: 'Contato',
      to: '/contato'
    }
  ];

  return (
    <footer className="site-footer">
      <Container>
        <Row className="g-4 align-items-start site-footer-main">
          <Col lg={5}>
            <div className="site-footer-brand">
              <img
                src={resolvePublicAsset('images/logo_acesso_popular_branco.png')}
                alt="Logo do Instituto Acesso Popular"
                className="site-footer-logo"
              />
              <p>
                O Instituto Acesso Popular atua na promoção da arte, da cultura e da educação como direitos fundamentais,
                fortalecendo expressões populares, periféricas e comunitárias.
              </p>
            </div>
          </Col>
          <Col sm={6} lg={3}>
            <div className="site-footer-column">
              <span className="site-footer-title">Navegação</span>
              <nav className="site-footer-nav" aria-label="Links do rodapé">
                {linksInstitucionais.map((item) => (
                  <Link key={item.to} to={item.to}>
                    {item.label}
                  </Link>
                ))}
              </nav>
            </div>
          </Col>
          <Col sm={6} lg={4}>
            <div className="site-footer-column">
              <span className="site-footer-title">Contato e redes</span>
              <div className="site-footer-contact-list">
                <p>Bauru - SP</p>
                <a href="mailto:contato@acessopopular.org.br">contato@acessopopular.org.br</a>
              </div>
              <SocialIcons />
            </div>
          </Col>
        </Row>
        <div className="site-footer-bottom">
          <hr className="site-footer-divider" />
          <p>© {new Date().getFullYear()} Instituto Acesso Popular. Todos os direitos reservados.</p>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;